import React from "react";

import difference from "lodash.difference";
import { observer } from "mobx-react";
import Link from "next/link";
import { useRouter, usePathname } from "../../hooks/useNavigation";
import PropTypes from "prop-types";
import styled from "styled-components";
import GBFlag from "svg-country-flags/svg/gb.svg";
import ThaiFlag from "svg-country-flags/svg/th.svg";

const StyledFlagWrapper = styled.div`
  &:last-child {
    margin-right: 0 !important;
  }
`;

const flagMap = {
  "en-GB": GBFlag,
  "th-TH": ThaiFlag,
};

function LocaleSelector(props) {
  const {
    flagHeight = 20,
    flagWrapperClassName = "me-3",
    showAllLocales = false,
  } = props;

  const router = useRouter();
  const pathname = usePathname();

  const localesToDisplay = showAllLocales
    ? router.locales || []
    : difference(router.locales || [], [router.locale]);

  return (
    <div className="d-flex" id="locale-selector">
      {localesToDisplay.map((singleLocale) => {
        const FlagComponent = flagMap[singleLocale];
        return (
          <StyledFlagWrapper
            key={singleLocale}
            className={flagWrapperClassName}
          >
            <Link href={pathname} locale={singleLocale} scroll={false}>
              {FlagComponent && <FlagComponent height={flagHeight} />}
            </Link>
          </StyledFlagWrapper>
        );
      })}
    </div>
  );
}

export default observer(LocaleSelector);

LocaleSelector.propTypes = {
  flagHeight: PropTypes.number,
  flagWrapperClassName: PropTypes.string,
  showAllLocales: PropTypes.bool,
};

LocaleSelector.defaultProps = {
  flagHeight: 20,
  flagWrapperClassName: "me-3",
  showAllLocales: false,
};
